const readSingleUseValue = Symbol('readSingleUseValue');

/** Allows a value to be freed from memory after it's been read once. */
export class SingleUseValue<T> {
  constructor(value: T) {
    this.value = value;
  }

  private value: T | typeof readSingleUseValue;

  hasValue() {
    return this.value !== readSingleUseValue;
  }

  readValue() {
    const {value} = this;
    if (value === readSingleUseValue) {
      throw new Error('The value was already read once.');
    }

    this.value = readSingleUseValue;
    return value;
  }

  withValue(callback: (value: T) => void) {
    if (this.hasValue()) {
      callback(this.readValue());
    }
  }
}
